/**
 * Format a GBP amount in compact human-readable form.
 * 200000   → "£200k"
 * 1200000  → "£1.2m"
 * 50000000 → "£50m"
 */
export function formatGbp(n) {
    if (n == null) return "—";
    const abs = Math.abs(n);
    if (abs >= 1_000_000) {
        const v = n / 1_000_000;
        return `£${v >= 10 ? Math.round(v) : v.toFixed(1)}m`;
    }
    if (abs >= 1_000) {
        return `£${Math.round(n / 1_000)}k`;
    }
    return `£${n}`;
}

/**
 * Format a "last updated" ISO timestamp as relative time, e.g. "2 days ago".
 */
export function formatRelative(iso) {
    if (!iso) return "—";
    const now = Date.now();
    const t = new Date(iso).getTime();
    const diff = Math.max(0, now - t) / 1000;
    if (diff < 60) return "just now";
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86_400) return `${Math.floor(diff / 3600)}h ago`;
    if (diff < 604_800) return `${Math.floor(diff / 86_400)}d ago`;
    if (diff < 2_592_000) return `${Math.floor(diff / 604_800)}w ago`;
    return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}
